import { get, rIC } from "../../utils";

async function load() {
  // Registers the <price-range> custom element used by the price facet.
  import("./PriceRange");
  const { Facets } = await import("./Facets");
  new Facets();
}

function facetsController() {
  const elFacets = get(".js-facets");
  if (elFacets) load();
}

export default () => rIC(facetsController);
